import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHotelDynamicDetails } from "../../context";
import useStepFlow from "src/Modules/Hotels/hooks/useStepsFlow";
import { usePriceBreakdown } from "src/Modules/Hotels/hooks/usePriceBreakdown";
import { HotelDetailsOverview } from "../HotelDetailsOverview";
import HotelMoneyBreakdown from "../HotelMoneyBreakdown/HotelMoneyBreakdown";
import { RoomSelection } from "../RoomSelection";
import GuestSummaryCard from "../GuestSummaryCard/GuestSummary";



export default function HotelSidebar() {
  const { hotel, selectedRoom, pointsFactor } = useHotelDynamicDetails();
  const { currentStep } = useStepFlow();
  const isPaymentStep = currentStep === 1;

  const price = usePriceBreakdown({ hotel, selectedRoom, pointsFactor });

  return (
    <div className="flex flex-col gap-4">
      <HotelDetailsOverview />
      <RoomSelection />
       <GuestSummaryCard/>
      <HotelMoneyBreakdown price={price} isPaymentStep={isPaymentStep} />
    </div>
  );
}
